/**
 * Routes of the discount engine screens (FSD 5.2.4; P45 UDM), spread into
 * `SALES_ROUTES`.
 *
 * Each route names the permission the server guards the screen's primary read
 * with (the module rule): the matrix and types read with `sales.discount.read`,
 * margin floors with `sales.margin.read` (seeing a floor is seeing margin).
 *
 * The Authority Matrix keeps the route NAME `sales-discount-policies` (the nav id
 * PS3-INT keeps) at its new path; the legacy `/sales/discount-policies` redirect
 * is INT's (`router/legacyRedirects.ts`). Paths are literal strings so the
 * conformance deep-link parser can read them.
 */

import type { RouteRecordRaw } from 'vue-router'

import { DISCOUNT_PERMISSIONS } from '@/modules/sales/discounts/permissions'

export const DISCOUNT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/sales/authority-matrix',
    name: 'sales-discount-policies',
    component: () => import('@/modules/sales/discounts/AuthorityMatrixView.vue'),
    meta: {
      titleKey: 'sales.discounts.routeTitles.authorityMatrix',
      permission: DISCOUNT_PERMISSIONS.read,
    },
  },
  {
    path: '/sales/discount-types',
    name: 'sales-discount-types',
    component: () => import('@/modules/sales/discounts/DiscountTypesView.vue'),
    meta: {
      titleKey: 'sales.discounts.routeTitles.discountTypes',
      permission: DISCOUNT_PERMISSIONS.read,
    },
  },
  {
    path: '/sales/margin-floors',
    name: 'sales-margin-floors',
    component: () => import('@/modules/sales/discounts/MarginFloorsView.vue'),
    meta: {
      titleKey: 'sales.discounts.routeTitles.marginFloors',
      permission: DISCOUNT_PERMISSIONS.marginRead,
    },
  },
]
